export default {
  meta: {
    title: '角色管理'
  }
};
